export default "__VITE_ASSET___Cv9WD0J__"